document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Language ring ---------- */
  var ring = document.getElementById('langRing');
  if (ring) {
    var words = ["Hello", "Bonjour", "Hola", "こんにちは", "안녕하세요", "สวัสดี", "Hallo", "你好", "Ciao", "Olá"];
    var wrap = ring.parentElement;

    function buildRing() {
      ring.innerHTML = '';
      var radius = wrap.offsetWidth * 0.46;
      words.forEach(function (w, i) {
        var angle = (360 / words.length) * i;
        var span = document.createElement('span');
        span.style.transform = 'rotate(' + angle + 'deg) translate(' + radius + 'px)';
        var inner = document.createElement('span');
        inner.className = 'inner';
        inner.textContent = w;
        inner.style.transform = 'rotate(' + (-angle) + 'deg)';
        span.appendChild(inner);
        ring.appendChild(span);
      });
    }

    buildRing();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(buildRing, 150);
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var sections = document.querySelectorAll('.ne20-section, .ne20-hero');
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
        }
      });
    }, { threshold: 0.15 });

    sections.forEach(function (s) {
      s.classList.add('ne20-reveal');
      revealObserver.observe(s);
    });
  }

  /* ---------- Image entrance animation ---------- */
  var animatedImages = document.querySelectorAll(
    '.ne20-translate-visual img, .ne20-case-grid img, .ne20-finish-card img, .ne20-app-strip img'
  );
  if ('IntersectionObserver' in window && animatedImages.length) {
    var imgObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = Array.prototype.indexOf.call(animatedImages, el) % 2 === 0 ? 0 : 90;
          setTimeout(function () { el.classList.add('in'); }, delay);
          imgObserver.unobserve(el);
        }
      });
    }, { threshold: 0.2 });

    animatedImages.forEach(function (img) {
      img.classList.add('ne20-img-reveal');
      imgObserver.observe(img);
    });
  }

  /* ---------- Count-up number ---------- */
  var countEl = document.getElementById('langCount');
  if (countEl) {
    var target = parseInt(countEl.getAttribute('data-target'), 10) || 0;
    var counted = false;

    function easeOutExpo(t) {
      return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
    }

    function runCount() {
      var duration = 1600;
      var start = performance.now();
      function tick(now) {
        var elapsed = now - start;
        var progress = Math.min(elapsed / duration, 1);
        var eased = easeOutExpo(progress);
        countEl.textContent = Math.round(eased * target);
        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          countEl.textContent = target;
        }
      }
      requestAnimationFrame(tick);
    }

    if ('IntersectionObserver' in window) {
      var countObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !counted) {
            counted = true;
            runCount();
            countObserver.disconnect();
          }
        });
      }, { threshold: 0.5 });
      countObserver.observe(countEl);
    } else {
      countEl.textContent = target;
    }
  }

  /* ---------- Variant picker ---------- */
  var variantSelects = document.querySelectorAll('.ne20-variant-select');
  var hiddenSelect = document.getElementById('ne20-variant-id');
  var variantDataEl = document.getElementById('ne20-variant-data');
  var moneyFormatEl = document.getElementById('ne20-money-format');
  var priceEl = document.querySelector('.ne20-price');
  var submitBtn = document.querySelector('#ne20-product-form button[name="add"]');

  var variants = [];
  if (variantDataEl) {
    try {
      variants = JSON.parse(variantDataEl.textContent);
    } catch (e) {
      variants = [];
    }
  }

  function formatMoney(cents) {
    if (!moneyFormatEl) return '$' + (cents / 100).toFixed(2);
    var format = moneyFormatEl.getAttribute('data-format') || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function currentSelection() {
    var values = [];
    variantSelects.forEach(function (sel) {
      var idx = parseInt(sel.getAttribute('data-option-index'), 10);
      values[idx] = sel.value;
    });
    return values;
  }

  function findMatchingVariant(values) {
    return variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return values.every(function (val, i) {
        return val === undefined || opts[i] === val;
      });
    });
  }

  function syncVariant() {
    if (!variants.length) return;
    var values = currentSelection();
    var match = findMatchingVariant(values);
    if (match) {
      if (hiddenSelect) hiddenSelect.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (submitBtn) {
        if (match.available) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Add to Cart';
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sold Out';
        }
      }
    }
  }

  variantSelects.forEach(function (sel) {
    sel.addEventListener('change', syncVariant);
  });

  if (variantSelects.length) {
    syncVariant();
  }
});
